import { Boxes, Sparkles } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { badgeVariants } from 'src/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import { cn } from 'src/lib/utils';

type ProductBadgesProps = {
  isNovelty: boolean;
  isDestocking: boolean;
};

export function ProductBadges({ isNovelty, isDestocking }: ProductBadgesProps) {
  const { t } = useTranslation('forecast');

  if (!isNovelty && !isDestocking) {
    return null;
  }

  return (
    <div className='flex flex-col gap-y-2'>
      {isNovelty && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger
              className={cn(
                badgeVariants({ variant: 'pillsInfo' }),
                'w-fit cursor-help gap-1',
              )}
            >
              <Sparkles className='size-3' />
              {t('Novelty')}
            </TooltipTrigger>
            <TooltipContent>
              <p>
                {t(
                  'The forecast proposal curve is based on the sales potential launch curve instead of the model forecast',
                )}
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      {isDestocking && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger
              className={cn(
                badgeVariants({ variant: 'pillsWarning' }),
                'w-fit cursor-help gap-1',
              )}
            >
              <Boxes className='size-3' />
              {t('Destocking')}
            </TooltipTrigger>
            <TooltipContent>
              <p>{t('This product is being destocked')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
